/* eslint-disable react/no-unused-prop-types */
import React from 'react';

import { formatPhoneNumber } from '@skippay/core/utils/apiUtils';

interface Props {
	countryCode: string;
	number: string;
	omitCountryCode?: boolean;
	children?: (props: { phoneNumber: string; href: string }) => JSX.Element;
}

function FormattedPhone(props: Props): JSX.Element {
	const { omitCountryCode } = props;
	const phoneNumber = formatPhoneNumber(props, { omitCountryCode, spacedTriples: true });

	return (
		<span data-clarity-mask="true">
			{props.children?.({ phoneNumber, href: `tel:${formatPhoneNumber(props)}` }) || phoneNumber}
		</span>
	);
}

export default FormattedPhone;
